import { createActionConst } from '../../../utils/action.utils';

const SCORE_NAMESPACE = 'SCORE';

export const STORE_SCORE = createActionConst(SCORE_NAMESPACE, 'STORE_SCORE');
export const CLEAR_SCORE = createActionConst(SCORE_NAMESPACE, 'CLEAR_SCORE');
